import { useQuery } from 'react-query';
import { fetchBloodPressurePhysicalExamination } from '@higo/api/lib/services';
import { useExaminationApiContext } from '@higo/common/src/features/ExaminationPage/providers';
import { ExaminationQueryKey } from '@higo/common/src/features/ExaminationPage/ExaminationQueryKey';

export const useBloodPressurePhysicalExaminationQuery = (
  examinationId: number,
  enabled = !isNaN(examinationId),
) => {
  const axios = useExaminationApiContext();

  return useQuery(
    [ExaminationQueryKey.BloodPressurePhysicalExamination, examinationId],
    async () => fetchBloodPressurePhysicalExamination(axios)(examinationId),
    {
      enabled,
    },
  );
};
